import { render, staticRenderFns } from "./EducationProtocolNew.vue?vue&type=template&id=6ccfe2ec&"
import script from "./EducationProtocolNew.vue?vue&type=script&lang=ts&"
export * from "./EducationProtocolNew.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports